import * as React from "react";
import { format } from "date-fns";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import {
    Box,
    Grid,
    Stack,
    TextField,
    FormControl,
    FormLabel,
    RadioGroup,
    Radio,
    FormControlLabel,
    Typography,
    Chip,
    Divider,
    Button
} from "@mui/material";

import SimpleTable from "../../Common/SimpleTable";

export default function ApplyForLeave({
    date,
    handleDate,
    remark,
    handleRemark,
    pastLeaveColumns,
    upcomingLeaveColumns,
    handleApplyForLeave,
    leaveTypeRadio,
    handleLeaveTypeRadio,
    handleDeleteDate,
    teamImpactColumns
}) {

    const pastLeave = [
        { id: 1, date: "27-Aug-2025", leaveDetails: "Sat-Off", status: "Approved" },
        { id: 2, date: "13-Aug-2025", leaveDetails: "Leave", status: "Approved" },
        { id: 3, date: "12-Aug-2025", leaveDetails: "HD-Post", status: "Approved" },
        { id: 4, date: "04-Aug-2025", leaveDetails: "Leave", status: "Approved" }
    ];

    const upcomingLeave = [
        { id: 1, date: "13-Sept-2025", leaveDetails: "Sat-Off", status: "Pending" },
        { id: 2, date: "22-Sept-2025", leaveDetails: "Function", status: "Pending" },
        { id: 3, date: "23-Sept-2025", leaveDetails: "Function", status: "Pending" },
        { id: 4, date: "27-Oct-2025", leaveDetails: "Sat-Off", status: "Pending" },
        { id: 5, date: "27-Oct-2025", leaveDetails: "Sat-Off", status: "Pending" },
        { id: 6, date: "27-Oct-2025", leaveDetails: "Sat-Off", status: "Pending" },
    ];

    const executiveStatusList = [
        { id: 1, executiveName: "Aditi Kadam - SAPL349", status: "Approved" },
        { id: 2, executiveName: "Pramila Khamkar - SAPL024", status: "Approved" },
        { id: 3, executiveName: "Aditi Kadam - SAPL349", status: "Approved" },
        { id: 4, executiveName: "Pramila Khamkar - SAPL024", status: "Approved" }
    ];

    const tableMaxHeight = date.length > 0 ? "24vh" : "60vh";

    return (
        <Box sx={{ p: 1 }}>
            <Grid container spacing={2} alignItems="stretch">

                {/* LEFT PANEL */}
                <Grid item xs={12} md={4} >
                    <Box
                        sx={{
                            height: "68vh",
                            display: "flex",
                            flexDirection: "column"
                        }}
                    >

                        {/* SCROLLABLE AREA */}
                        <Box
                            sx={{
                                flex: 1,
                                overflowY: "auto",
                                px: 2,
                                py: 2
                            }}
                        >

                            <Stack spacing={2}>

                                {/* DATE PICKER */}
                                <FormControl fullWidth size="small">
                                    <FormLabel
                                        sx={{
                                            mb: 0.5,
                                            "&::after": { content: '" *"', color: "red" }
                                        }}
                                    >
                                        Select Date
                                    </FormLabel>

                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DesktopDatePicker
                                            value={null}
                                            onChange={handleDate}
                                            inputFormat="dd/MMM/yyyy"
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    size="small"
                                                    placeholder={date.length === 0 ? "dd/MMM/yyyy" : ""}
                                                    sx={{
                                                        "& .MuiInputBase-input": {
                                                            opacity: 0,
                                                            width: "1px"
                                                        }
                                                    }}
                                                    InputProps={{
                                                        ...params.InputProps,

                                                        startAdornment: (
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    flexWrap: "wrap",
                                                                    gap: 0.5,
                                                                    alignItems: "center",
                                                                    flex: 1
                                                                }}
                                                            >
                                                                {date.map((d, index) => (
                                                                    <Chip
                                                                        key={index}
                                                                        size="small"
                                                                        label={format(d, "dd-MMM-yyyy")}
                                                                        onDelete={date.length > 1 ? () => handleDeleteDate(index) : undefined}
                                                                        sx={{
                                                                            backgroundColor: date.length === 1 ? "" : "#ffff"
                                                                        }}
                                                                    />
                                                                ))}
                                                            </Box>
                                                        ),

                                                        endAdornment: params.InputProps?.endAdornment
                                                    }}
                                                />
                                            )}
                                        />
                                    </LocalizationProvider>
                                </FormControl>

                                {/* MULTIPLE DATE CARDS */}

                                {date.map((d, index) => (
                                    <Box
                                        key={index}
                                        sx={{
                                            border: "1px solid #E5E7EB",
                                            borderRadius: "10px",
                                            p: 1.5
                                        }}
                                    >
                                        <Typography sx={{ fontSize: 12 }}>
                                            {format(d, "dd-MMM-yyyy")}{" "}
                                            <Typography component="span" sx={{ color: "#717883", fontSize: 12 }}>
                                                ({format(d, "EEEE")})
                                            </Typography>
                                        </Typography>

                                        <RadioGroup
                                            value={leaveTypeRadio[format(d, "dd-MMM-yyyy")] || ""}
                                            onChange={(e) => handleLeaveTypeRadio(e, d)}
                                        >
                                            <Grid container spacing={1}>

                                                <Grid item xs={4}>
                                                    <FormControlLabel value="Full Day" control={<Radio />} label="Full Day" />
                                                </Grid>

                                                <Grid item xs={4}>
                                                    <FormControlLabel value="Post Lunch" control={<Radio />} label="Post Lunch" />
                                                </Grid>

                                                <Grid item xs={4}>
                                                    <FormControlLabel value="Pre Lunch" control={<Radio />} label="Pre Lunch" />
                                                </Grid>

                                                <Grid item xs={4}>
                                                    <FormControlLabel value="Sat Off" control={<Radio />} label="Sat Off" />
                                                </Grid>

                                                <Grid item xs={4}>
                                                    <FormControlLabel value="Travel" control={<Radio />} label="Travel" />
                                                </Grid>

                                                <Grid item xs={4}>
                                                    <FormControlLabel value="Work From Home" control={<Radio />} label="Work From Home" />
                                                </Grid>

                                            </Grid>
                                        </RadioGroup>
                                    </Box>
                                ))}

                                {/* REMARK */}
                                <FormControl fullWidth>
                                    <FormLabel>Remark</FormLabel>
                                    <TextField
                                        multiline
                                        rows={3}
                                        value={remark}
                                        onChange={handleRemark}
                                        placeholder="Enter Remark"
                                    />
                                </FormControl>

                            </Stack>
                        </Box>

                        {/* APPLY BUTTON */}
                        <Box>
                            <Divider sx={{ mt: 1 }} />
                            <Box sx={{ display: "flex", justifyContent: "flex-end", pt: 1.5, px: 2 }}>
                                <Button
                                    variant="contained"
                                    sx={{ width: 200 }}
                                    onClick={handleApplyForLeave}
                                >
                                    Apply
                                </Button>
                            </Box>
                        </Box>

                    </Box>
                </Grid>

                {/* VERTICAL DIVIDER */}
                <Grid item>
                    <Divider
                        orientation="vertical"
                        sx={{
                            borderColor: "#D1D5DB"
                        }}
                    />
                </Grid>

                {/* RIGHT PANEL */}
                <Grid item xs={12} md={7.8}>
                    <Box sx={{ height: "68vh", overflowY: "auto", px: 2 }}>

                        <Grid container spacing={4}>

                            {/* Past Leaves */}
                            <Grid item xs={12} md={6}>
                                <SimpleTable
                                    title="Past Leaves"
                                    rows={pastLeave}
                                    columns={pastLeaveColumns}
                                    maxHeight={tableMaxHeight}
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <SimpleTable
                                    title="Upcoming Applied Leaves"
                                    rows={upcomingLeave}
                                    columns={upcomingLeaveColumns}
                                    maxHeight={tableMaxHeight}
                                />
                            </Grid>

                            {/* TEAM IMPACT TABLES */}
                            {date.length > 0 &&
                                date.map((selectedDate, index) => {

                                    const formattedDate = format(selectedDate, "dd-MMM-yyyy");

                                    return (
                                        <React.Fragment key={index}>

                                            <Grid item xs={12} md={6}>
                                                <Box sx={{ width: "100%" }}>
                                                    <SimpleTable
                                                        title={`Team Impact (${formattedDate})`}
                                                        rows={executiveStatusList}
                                                        columns={teamImpactColumns}
                                                        maxHeight={tableMaxHeight}
                                                    />
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <Box sx={{ width: "100%" }}>
                                                    <SimpleTable
                                                        title={`Project Impact (${formattedDate})`}
                                                        rows={executiveStatusList}
                                                        columns={teamImpactColumns}
                                                        maxHeight={tableMaxHeight}
                                                    />
                                                </Box>
                                            </Grid>

                                        </React.Fragment>
                                    );
                                })}

                        </Grid>

                    </Box>
                </Grid>

            </Grid>
        </Box>

    );
}